<div class="body-categoria py-5 px-2">
    <div class="box-content mx-auto mw-100">
      <img class="mw-100 d-block mx-auto margin-logo" width="30%"  src="assets/img/logo.png" alt="">
      <p class="text-center fs-5">Tiendas QuinChau</p>
      <ul class="custom-list">
        <li class="expandable" (click)="navegarACatalogo('relevancia_producto','desc')">
            Productos mas vendidos
            <span class="icon">
              <i class="fas fa-chevron-down"></i>
            </span>
        </li>
        <li class="expandable" (click)="navegarACatalogo('reciente','desc')">
            Productos recientes
            <span class="icon">
              <i class="fas fa-chevron-down"></i>
            </span>
          </li>
          <li class="expandable" >
            <div (click)="toggleExpand()">
              Modelos y Categorías
              <span class="icon" >
                <i [ngClass]="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
              </span>
            </div>
            <div class="content" [ngClass]="{'mat-hide': !expanded}">
              <!-- Coloca aquí el contenido de los modelos y categorías -->
              <!-- Por ejemplo, podrías agregar una lista de modelos y categorías -->
              <ul class="categories">
                <!-- <mat-option *ngFor="let tag of tags.registros; let i = index;" [value]="tag.idmodelo">{{ tag.marca_modelo }}</mat-option> -->

                <li *ngFor="let tag of tags.registros; let i = index;" (click)="tomarTag(tag.idmodelo,tag.marca_modelo)">{{ tag.marca_modelo }}</li>
                <!-- ... Agrega más modelos y categorías aquí ... -->
              </ul>
            </div>
          </li>
          
          <li class="expandable"  (click)="navegarACotizaciones()">
              Ordenes pendientes
              <span class="icon">
                <i class="fas fa-chevron-down"></i>
              </span>
          </li>
          <li class="expandable"  (click)="obtenerRegistrosPaginados()">
            Descargar listado 
            <span class="icon">
              <i class="fas fa-chevron-down"></i>
            </span>
          </li>

        
          <!-- <li class="expandable">
              Ordenes Procesadas
              <span class="icon">
                <i class="fas fa-chevron-down"></i>
              </span>
          </li> -->
        <!-- Resto de los elementos de la lista -->
      </ul>
    </div>
  </div>
  

